import authService from '@platform/core/src/services/authService';
import config from '@platform/core/src/config';

const API_BASE_URL = config.API_BASE_URL;
const BIO_LOGS_API_URL = `${API_BASE_URL}/api/v1/bio-logs`;

export const getBioLogs = async (options = {}) => {
  const url = new URL(BIO_LOGS_API_URL);
  if (options.type) url.searchParams.append('type', options.type);
  if (options.start_date) url.searchParams.append('start_date', options.start_date);
  if (options.end_date) url.searchParams.append('end_date', options.end_date);

  try {
    const response = await authService.authFetch(url.toString());
    if (!response.ok) throw new Error(`Failed to fetch bio logs: ${response.status}`);
    return await response.json();
  } catch (error) {
    console.error('[workoutsmart/bioLogsApi] Error fetching logs:', error);
    authService.trackNetworkError('getBioLogs', error);
    throw error;
  }
};

export const getBioLogById = async (id) => {
  const url = `${BIO_LOGS_API_URL}/${id}`;
  try {
    const response = await authService.authFetch(url);
    if (!response.ok) throw new Error(`Failed to fetch bio log: ${response.status}`);
    return await response.json();
  } catch (error) {
    console.error('[workoutsmart/bioLogsApi] Error fetching log by ID:', error);
    throw error;
  }
};

export const createBioLog = async (logData) => {
  try {
    const response = await authService.authFetch(BIO_LOGS_API_URL, {
      method: 'POST',
      body: logData,
    });
    if (!response.ok) throw new Error(`Failed to create log: ${response.status}`);
    return await response.json();
  } catch (error) {
    console.error('[workoutsmart/bioLogsApi] Error creating log:', error);
    throw error;
  }
};

export const updateBioLog = async (id, logData) => {
  const url = `${BIO_LOGS_API_URL}/${id}`;
  try {
    const response = await authService.authFetch(url, {
      method: 'PUT',
      body: logData,
    });
    if (!response.ok) throw new Error(`Failed to update log: ${response.status}`);
    return await response.json();
  } catch (error) {
    console.error('[workoutsmart/bioLogsApi] Error updating log:', error);
    throw error;
  }
};

// NEW: PATCH method to avoid overwriting data
export const patchBioLog = async (id, logData) => {
  const url = `${BIO_LOGS_API_URL}/${id}`;
  try {
    const response = await authService.authFetch(url, {
      method: 'PATCH',
      body: logData,
    });
    if (!response.ok) throw new Error(`Failed to patch log: ${response.status}`);
    return await response.json();
  } catch (error) {
    console.error('[workoutsmart/bioLogsApi] Error patching log:', error);
    throw error;
  }
};

export const deleteBioLog = async (id) => {
  const url = `${BIO_LOGS_API_URL}/${id}`;
  try {
    const response = await authService.authFetch(url, { method: 'DELETE' });
    if (!response.ok) throw new Error(`Failed to delete log: ${response.status}`);
  } catch (error) {
    console.error('[workoutsmart/bioLogsApi] Error deleting log:', error);
    throw error;
  }
};